import * as React from 'react';
import { IStatusMessage } from '../../../Models/IStatusMessage';
import { EmptyProfileContact, IProfileContact } from '../../../Models/Profile/IProfileContact';
import { InvoiceContactView } from './InvoiceContactView';
import * as Services from '../../../Services/Services';
import { IProfileApi } from '../../../Services/API/Profile/IProfileApi';
import { MessageBarType } from '@fluentui/react';
import { IUserProfile } from '../../../Models/Profile/IUserProfile';
import { IAppStore } from '../../../Stores/IAppStore';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { connect } from 'react-redux';

interface IInvoiceContactProps {
    profile: IUserProfile,
}

export const InvoiceContact: React.FunctionComponent<IInvoiceContactProps> = (props) => {

   
    const [isLoading, setIsLoading] = React.useState(false);

    const [contactInfo, setContactInfo] = React.useState<IProfileContact>(EmptyProfileContact());
    
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>()

    const infoPropertyChanged = (key: string, value: any) => {
        var contact = { ...contactInfo, [key]: value };
        if (!contact.differentBillingAddress) {
            contact = {
                ...contact,
                billingCity: contact.city,
                billingEmail: props.profile.email,
                billingPostalCode: contact.postalCode,
                billingStreet: contact.street
            }
        }

        setContactInfo(contact);
    }
 

   
    //React.useEffect(() => {

    //    if (!contactInfo.differentBillingAddress) {
    //        setContactInfo({
    //            ...contactInfo,
    //            billingCity: contactInfo.city,
    //            billingEmail: "",
    //            billingPostalCode: contactInfo.postalCode,
    //            billingStreet: contactInfo.billingStreet               
    //        });
    //    }
    //}, [contactInfo])


    const loadProfileInfo = async () => {
        setIsLoading(true);
        setStatusMessage(undefined);
        const profileApi = Services.ServicesProvider.GetService<IProfileApi>(Services.ProfileApi);
        const profile = await profileApi.getProfileContact();
        
        if (profile.isSuccess && profile.data) {
            setContactInfo(profile.data);
            setStatusMessage({ message: profile.message, type: MessageBarType.success });            
        }
        else {
            setStatusMessage({ message: profile.message, type: MessageBarType.error });
        }
        setIsLoading(false);
    }

    React.useEffect(() => {
        loadProfileInfo();
    },[])

    const saveProfile = async () => {
        setIsLoading(true);
        setStatusMessage(undefined);
        const profileApi = Services.ServicesProvider.GetService<IProfileApi>(Services.ProfileApi);

        const profile = await profileApi.saveProfileContact(contactInfo);
        if (profile.isSuccess) {
            setStatusMessage({ message: profile.message, type: MessageBarType.success });
        }
        else {
            setStatusMessage({ message: profile.message, type: MessageBarType.error });
        }
        setIsLoading(false);
    }


    return (<InvoiceContactView
        isLoading={isLoading}
        contactInfo={contactInfo}
       
        //isPrivateInformationConsent={isPrivateInformationConsent}        
        changeInfoProperty={infoPropertyChanged}                
        saveProfile={saveProfile}
        statusMessage={statusMessage}/>)
}
const InvoiceContactToProps = (state: IAppStore) => ({
    profile: state.userProfileStore.profile,

});

const InvoiceContactDispatchToProps = (dispatch: ThunkDispatch<IAppStore, any, AnyAction>) => ({

});

export default connect(InvoiceContactToProps, InvoiceContactDispatchToProps)(InvoiceContact);

